/**
 * web-studio-sites 6.6: the marks of the events row and the events grid with the mine option, each from the event's own
 * `userBooking`. A booking waiting on payment takes the rest of its mark from the dashboard's copy of it: the one shared
 * read, held unless such a booking is listed, its reader mounted either way.
 */
import { useMemo } from 'react';
import type { SiteEventSummaryDto } from '@telify/shared';

import { useWebDashboard } from '../../hooks/useWebAccount';
import { eventMarks, needsDashboardCopy, type DashboardCopies } from '../../mine';
import type { MineMark } from './contract';

/** A copy the page read this recently serves, so a list that lands after Waiting on you's read makes no second read. */
const COPY_TRUSTED_MS = 60_000;

export function useEventMarks(events: readonly SiteEventSummaryDto[], on: boolean, tz: string): Readonly<Record<string, MineMark>> {
  const dashboard = useWebDashboard({ enabled: on && needsDashboardCopy(events), staleTime: COPY_TRUSTED_MS });
  const copies: DashboardCopies = dashboard.data ? dashboard.data.upcoming : dashboard.isError ? 'failed' : 'loading';
  return useMemo(() => (on ? eventMarks(events, copies, tz) : {}), [on, events, copies, tz]);
}
